Service = App.loadClass 'core::Angular/Service'

exports.register = (module) ->
    module.service 'Core.Services.Session', ['$cookies', exports.Session]

class exports.Session extends Service
    constructor: (@cookies) ->
        undefined

    set: (name, value) =>
        @cookies.put name, ('' + value)

    get: (name) =>
        @cookies.get name

    remove: (name) =>
        @cookies.remove name
